module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-menu",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-ctx"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("五险一金")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sbfw()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shebaofuwu-item"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("社保服务")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("社保查询、社保缴交")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.gjj()
      }
    }
  }, [_c('div', {
    staticClass: "menu-title"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-gongjijin-item"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("公积金")])]), _vm._v(" "), _c('span', {
    staticClass: "menu-desc"
  }, [_vm._v("公积金查询、缴交")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ff98e36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/insurance_dialog/insurance_dialog.vue
// module id = 318
// module chunks = 40